import { z } from "zod";
import type { Archive } from "../domain/types";
const envelope = z.object({
  format: z.enum([
    "mh-rp-archive-v1",
    "mh-rp-archive-v2",
    "mh-rp-archive-v3",
    "mh-rp-archive-v4",
    "mh-rp-archive-v5",
  ]),
  exportedAt: z.string(),
  archive: z.unknown(),
});
export function exportArchive(archive: Archive) {
  return JSON.stringify(
    {
      format: "mh-rp-archive-v5",
      exportedAt: new Date().toISOString(),
      archive,
    },
    null,
    2,
  );
}
export function importArchive(text: string): Archive {
  const parsed = envelope.parse(JSON.parse(text));
  const a = parsed.archive as Archive;
  if (
    !a ||
    typeof a.name !== "string" ||
    ![1, 2, 3, 4, 5].includes(a.meta?.version as number) ||
    a.player?.id !== "B1"
  )
    throw new Error("不是有效的怪物猎人存档");
  return a;
}
export function downloadArchive(archive: Archive) {
  const blob = new Blob([exportArchive(archive)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${archive.name}.怪物猎人.json`;
  a.click();
  URL.revokeObjectURL(url);
}
